export default __webpack_public_path__ + "static/media/arrow-left.76f9e833.svg";